var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"d-flex mt-6 py-3 background-transparent body-2 text-sm-body-1",attrs:{"outlined":"","icon":"admin_panel_settings","color":"primary-light"}},[_c('div',{staticClass:"pr-2 font-weight-medium text-center"},[_vm._v("Only visible to logged in users")])])
}
var staticRenderFns = []

export { render, staticRenderFns }